<!-- OfficeCardSelector.vue -->
<template>
  <div class="container">
    <div class="row g-3">
      <div
        v-for="office in offices"
        :key="office.id"
        class="col-12 col-md-6"
        @click="toggleSelection(office)"
        :class="{ selected: isSelected(office.id) }"
      >
        <div class="card h-100">
          <img :src="office.image" class="card-img-top" alt="Office Image" />
          <div class="card-body">
            <h5 class="card-title">{{ office.name }}</h5>
            <p class="card-text">{{ office.address }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, toRefs } from 'vue'

const props = defineProps({
  offices: { type: Array, required: true },
  multiple: { type: Boolean, default: false },
  selectById: { type: Boolean, default: false }
})

const { offices, multiple } = toRefs(props)

const emit = defineEmits(['update:selectedOffices'])

const selectedOffices = ref([])

watch(selectedOffices, (newVal) => {
  emit('update:selectedOffices', newVal)
})

const toggleSelection = (office) => {
  if (multiple.value) {
    const index = selectedOffices.value.findIndex((o) => o.id === office.id)
    if (index === -1) {
      selectedOffices.value.push(office)
    } else {
      selectedOffices.value.splice(index, 1)
    }
  } else {
    if (props.selectById) {
      selectedOffices.value = office.id
    } else {
      selectedOffices.value = [office]
    }
  }
}

const isSelected = (officeId) => {
  if (props.selectById) {
    return officeId === selectedOffices.value
  }
  return selectedOffices.value.some((office) => office.id === officeId)
}

const onShow = (offices) => {
  if (Array.isArray(offices)) {
    if (props.selectById) {
      selectedOffices.value = offices[0]?.id || null
    } else {
      selectedOffices.value = offices
    }
  } else if (typeof offices === 'object' && offices !== null) {
    if (props.selectById) {
      selectedOffices.value = offices.id || null
    } else {
      selectedOffices.value = [offices]
    }
  } else {
    if (props.selectById) {
      selectedOffices.value = null
    }
    selectedOffices.value = []
  }
}

const resetSelected = () => {
  if (props.selectById) {
    selectedOffices.value = null
  } else {
    selectedOffices.value = []
  }
}

defineExpose({
  toggleSelection,
  resetSelected,
  onShow
})
</script>

<style scoped>
.card {
  cursor: pointer;
  transition:
    transform 0.3s,
    box-shadow 0.3s;
}

.card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.selected .card {
  border: 2px solid #007bff;
}
</style>
